import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { ListarMarketplaces } from "../pages/ListarMarketplaces";
import { CadastrarEditarMarketplace } from "../pages/CadastrarEditarMarketplace";
import { DetalhesMarketplace } from "../pages/DetalhesMarketplace";
import { PersonalizarMarketplace } from "../pages/PersonalizarMarketplace";
import { Layout } from "../../core/components/Layout";
import { ConfiguracoesPedidoProvider } from "../../pedidos/contexts/ConfiguracoesPedidoContext";

interface IMarketPlaceProps {
    autenticado: boolean;
}

export const MarketplaceRoutes = ({ autenticado }: IMarketPlaceProps) => {
    return (
        <ConfiguracoesPedidoProvider>
            <Routes>
                <Route element={
                    <Layout titulo="Marketplaces">
                        <PrivateRoutes
                            autenticado={autenticado}
                        />
                    </Layout>
                }>
                    <Route path="/" element={<ListarMarketplaces />} />
                    <Route path="/:uuid" element={<DetalhesMarketplace />} />
                    <Route path="/cadastrar" element={<CadastrarEditarMarketplace />} />
                    <Route path="/editar/:uuid" element={<CadastrarEditarMarketplace />} />
                    <Route path="/personalizar/:uuid" element={<PersonalizarMarketplace />} />
                    <Route path="*" element={<Navigate to="/pagina-nao-encontrada" />} />
                </Route>
            </Routes>
        </ConfiguracoesPedidoProvider>
    );
}